module.exports = __webpack_public_path__ + "static/media/Andrina 3.c4b24ec6.png";